import React, {useEffect, useMemo} from 'react';
import {useIntl} from 'react-intl';
import {Formik} from 'formik';
import {
  useCitiesContext,
  useStreetsContext
} from '../../../_common/components/CitiesAndStreets';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import FilterDropdown from "../../../_common/components/FilterDropdown";
import FilterText from '../../../_common/components/FilterText';
import {DatePicker} from '../../../_common/components/FieldDatepicker';
import {useOldInspectionsPageUIContext} from '../OldInspectionsPageUIContext';
import {filterOptions} from "../../../../../utils/filterOptions";
import {applyFilter} from "../../../../../utils/prepareApplyFilter";
import styles from './styles.module.scss';
import FilterSelect from '../../../_common/components/FilterSelect';

export function OldInspectionsPageFilters() {
  const intl = useIntl();
  const oldInspectionsUIContext = useOldInspectionsPageUIContext();
  const oldInspectionsUIProps = useMemo(() => {
    return {
      queryParams: oldInspectionsUIContext.queryParams,
      setQueryParams: oldInspectionsUIContext.setQueryParams,
    };
  }, [oldInspectionsUIContext]);
  const {cities} = useCitiesContext();
  const {streets, updateStreets} = useStreetsContext();

  const qs = new URLSearchParams(window.location.search);
  let cityID = qs.get('cityID') || '';
  let streetID = qs.get('streetID') || '';
  let gush = qs.get('gush') || '';
  let helka = qs.get('helka') || '';
  let toDate = qs.get('toDate') || '';
  let fromDate = qs.get('fromDate') || '';

  useEffect(() => {
    if (cityID) {
      updateStreets(cityID);
    }
  }, []);

  const handleCityChange = values => selected => {
    const {cityID} = values;
    if (!cityID || cityID !== selected.value) {
      updateStreets(selected.value);
    }
  };
  const onChangeCityID = (values) => (value) => (setFieldValue, handleSubmit, handleCityChange) => {
    setFieldValue('cityID', value);
    setFieldValue('streetID', '');
    handleSubmit();
    handleCityChange(values)({value});
  };

  const filterClassnames = 'col-lg position-relative';
  const prefix = 'filter-placeholder';

  return (
    <Formik
      initialValues={{
        cityID,
        streetID,
        gush,
        helka,
        fromDate,
        toDate,
      }}
      onSubmit={(values) => applyFilter(values, oldInspectionsUIProps)}
      enableReinitialize={true}
    >
      {({values, handleBlur, handleSubmit, setFieldValue}) => (
        <form onSubmit={handleSubmit} className={styles.formFilters}>
          <div className="form-group row d-flex mb-0 ml-8">
            <FilterDropdown
              name="cityID"
              value={filterOptions(values.cityID)(cities)}
              onChangeValue={({value}) => onChangeCityID(values)(value)(setFieldValue, handleSubmit, handleCityChange)}
              options={cities}
              placeholder={intl.formatMessage({id: `${prefix}-city`, defaultMessage: 'City'})}
              onClearValue={() => {
                setFieldValue('cityID', '');
                setFieldValue('streetID', '');
                handleSubmit();
              }}
              customContainerClassname={filterClassnames}
            />
            <FilterSelect
              fieldName={'streetID'}
              valueName={values.streetID}
              options={streets || []}
              placeholder={intl.formatMessage({id: `${prefix}-street`, defaultMessage: 'Street'})}
              containerClassnames={filterClassnames}
              disabled={!values.cityID}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <FilterText
              fieldName={'gush'}
              value={values.gush}
              placeholder={intl.formatMessage({id: `${prefix}-gush`, defaultMessage: 'Gush'})}
              containerClassnames={filterClassnames}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <FilterText
              fieldName={'helka'}
              value={values.helka}
              placeholder={intl.formatMessage({id: `${prefix}-helka`, defaultMessage: 'Helka'})}
              containerClassnames={filterClassnames}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <div className="col-lg position-relative">
              <DatePicker
                className="pl-4"
                placeholder={intl.formatMessage({id: `${prefix}-fromDate`, defaultMessage: 'From date'})}
                value={fromDate}
                onChange={date => {
                  setFieldValue('fromDate', date);
                  handleSubmit();
                }}
                maxDate={toDate}
              />
              <img
                src={toAbsoluteUrl('/media/common/Cross_BC.svg')}
                alt="clear-filter"
                className={styles.clearFilterIcon}
                onClick={() => {
                  setFieldValue('fromDate', '');
                  handleSubmit();
                }}
              />
            </div>
            <div className="col-lg position-relative">
              <DatePicker
                className="pl-4"
                placeholder={intl.formatMessage({id: `${prefix}-toDate`, defaultMessage: 'To date'})}
                value={toDate}
                onChange={date => {
                  setFieldValue('toDate', date);
                  handleSubmit();
                }}
                minDate={fromDate}
              />
              <img
                src={toAbsoluteUrl('/media/common/Cross_BC.svg')}
                alt="clear-filter"
                className={styles.clearFilterIcon}
                onClick={() => {
                  setFieldValue('toDate', '');
                  handleSubmit();
                }}
              />
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}

export default OldInspectionsPageFilters;
